import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || 'An error occurred';
  } if (error instanceof Error) {
    return error.message;
  }

  return 'Something went wrong';
};

export const saveFavorite = createAsyncThunk(
  'favorites/addFavorite',
  async ({ token, jobId }: { token: string; jobId: string }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/favs/save-fav/${jobId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        return response.data;
      }
      return rejectWithValue(response.data.message || 'Failed to add favorite');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 409) {
        return rejectWithValue('Job is already in your favorites');
      }
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const getFavorites = createAsyncThunk(
  'favorites/getFavorites',
  async ({ token }: { token: string }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/favs/get-favs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.favorites === undefined) {
        return rejectWithValue('favorites not found');
      }

      return { favorites: response.data.favorites };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const removeFavorite = createAsyncThunk(
  'favorites/removeFavorite',
  async ({ token, postId }: { token: string; postId: string }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/favs/remove-fav/${postId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const clearFavorites = createAsyncThunk(
  'favorites/clearFavorites',
  async ({ token }: { token: string }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/clear-favs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
